import { useState } from "react";
import Header from "../../components/Header";
import DashboardFilters from "./DashboardFilters";
import DashboardPetsTable from "./DashboardPetsTable";
import useAuth from "../../hooks/useAuth";


const DashboardPets = () => {

    const [idBrand, setIdBrand] = useState('0');
    const [idContactType, setIdContactType] = useState('0');
    const [idConsent, setIdConsent] = useState('0');
    const [dateFrom, setDateFrom] = useState('');
    const [dateUntil, setDateUntil] = useState('');
    const { auth } = useAuth();

    const handleDownload = async (filters = {}) => {
        try {
            const params = new URLSearchParams();

            Object.entries(filters).forEach(([key, value]) => {
                if (value === undefined || value === null || value === '') {
                    return;
                }
                if (key === 'year') {
                    return;
                }
                params.append(key, value);
            });

            const queryString = params.toString();
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}v1/dashboard/pets-export${queryString ? `?${queryString}` : ''}`,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${auth?.accessToken}`,
                        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    },
                    credentials: 'include',
                }
            );

            if (!response.ok) {
                throw new Error('Export failed');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `dashboard-pets-${new Date().toISOString().split('T')[0]}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading pets dashboard export', error);
            alert('No se pudo descargar el Excel. Intenta nuevamente.');
        }
    };

    return (
        <>
            <Header />
            
            <div className="content">

                <div className="table_div">

                <DashboardFilters
                    setIdBrand={setIdBrand}
                    setIdContactType={setIdContactType}
                    setDateFrom={setDateFrom}
                    setDateUntil={setDateUntil}
                    setIdConsent={setIdConsent}
                    onDownload={handleDownload}
                />


                </div>

                <DashboardPetsTable params={ { idBrand, idContactType, dateFrom, dateUntil, idConsent } } />

            </div>

        </>
    )
}

export default DashboardPets
